/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { FormatStatusIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Testimonials' ),
	description: __( 'Gutenify Testimonials' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Testimonial' ),
		__( 'Testimonials' ),
	],
	example: {
		attributes: {
			teams: {

			},
		},
	},
	attributes,
	edit,
	save,
	supports,
};

export { name, category, settings };
